export enum SpecialFilterValue {
  Unknown = "unknown",
}
